import React from 'react';
import styled from 'styled-components';
import { Carousel } from 'react-bootstrap';

import MansyurStoreImage from '../../Assets/Images/optik_1.png';
import KaryaStoreImage from '../../Assets/Images/optik_2.png';
import HalatStoreImage from '../../Assets/Images/optik_3.png';
import JohorStoreImage from '../../Assets/Images/store3A.png';
import RingroadStoreImage from '../../Assets/Images/optik_5.png';
import MarelanStoreImage from '../../Assets/Images/marelan.png'
import PancingStoreImage from '../../Assets/Images/pancing.png'
import { DefaultContainer } from '../../App';

const Title = styled.h1`
  font-family: 'Cabinet Grotesk', sans-serif;
  font-weight: bolder;
`;

const StoreMainTitle = styled(Title)`
  font-size: 3.5rem;

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

const SecondTitle = styled.h3`
  font-family: 'Cabinet Grotesk', sans-serif;
  font-weight: bolder;
`;

const Caption = styled.h5`
  font-family: 'Cabinet Grotesk', sans-serif;
  margin-top: 3vh;
`;

const StoreTitle = styled.h5`
  font-family: 'Cabinet Grotesk', sans-serif;
  font-weight: bolder;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const Button = styled.button`
  font-family: 'Cabinet Grotesk', sans-serif;
  border: none;
  background-color: white;
  border-radius: 8px;
  padding: 0.75vh 1.5vw;
  font-size: 1.7rem;
  font-weight: bold;
  margin-top: 2vh;
  color: black;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-top: 1vh;
    padding: 0.2vh 2vw;
  }
`;

const CarouselImage = styled.img`
  width: 100%;
  height: 100%;

  @media (max-width: 768px) {
    width: 200% !important;
    height: 200% !important;
  }
`;

const ImageSlider = () => {
  const slides = [
    {
      title: '150K Optik',
      description: 'Store#01 - Karya',
      location: 'https://goo.gl/maps/kR6N18aRzCDqYY4j7',
      imageUrl: KaryaStoreImage
    },
    {
      title: '150K Optik',
      description: 'Store#02 - Mansyur',
      location: 'https://goo.gl/maps/cxaxnrbeuWPJWt5i8',
      imageUrl: MansyurStoreImage
    },
    {
      title: '150K Optik',
      description: 'Store#03 - Halat',
      location: 'https://goo.gl/maps/FQtDnvWJxY3v2H536',
      imageUrl: HalatStoreImage
    },
    {
      title: '150K Optik',
      description: 'Store#04 - Ringroad',
      location: 'https://maps.app.goo.gl/GP7eLjFCTcVQyW3w7',
      imageUrl: RingroadStoreImage
    },
    {
      title: '150K Optik',
      description: 'Store#05 - Johor',
      location: 'https://maps.app.goo.gl/arrLVccoGn1siWrA9',
      imageUrl: JohorStoreImage
    },
    {
      title: '150K Optik',
      description: 'Store#06 - Marelan',
      location: 'https://maps.app.goo.gl/AxSAXhoPn5cbBQjb7',
      imageUrl: MarelanStoreImage
    },
    {
      title: '150K Optik',
      description: 'Store#07 - Pancing',
      location: 'https://maps.app.goo.gl/8DCoJCkiFNFJgmmf6',
      imageUrl: PancingStoreImage
    }
  ];


  return (
    <Carousel className='mt-5 rounded' fade={true}>
      {slides.map((slide, index) => (
        <Carousel.Item key={index}>
          <div className='slider-content'>
            <CarouselImage
              className='d-block'
              src={slide.imageUrl}
              alt={`Slide ${index + 1}`}
            />
            <div className='slider-caption'>
              <StoreTitle className='mb-lg-5'>{slide.title}</StoreTitle>
              <StoreMainTitle>{slide.description}</StoreMainTitle>
              <a href={slide.location} target='_blank'>
                <Button>Lokasi</Button>
              </a>
            </div>
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

const StoreComponent = (): React.JSX.Element => {
  return (
    <React.Fragment>
      <div className='pt-5 px-5' id='store'>
        <center>
          <Title>
            Gerai Kami
          </Title>
        </center>
      </div>
      <ImageSlider />

      <DefaultContainer>
        <SecondTitle>
          SATU HARGA UNTUK SEMUA
        </SecondTitle>
        <Caption>
          Satu harga untuk semua kacamata dengan kualitas premium. Dengan 170K dapatkan frame + lensa untuk semua jenis
          frame premium. Kami memiliki beragam pilihan kacamata untuk pria dan wanita, dari Cat Eyes, bulat sampai model
          Aviator.
        </Caption>
      </DefaultContainer>
    </React.Fragment>
  );
};

export default StoreComponent;
